// extracted by mini-css-extract-plugin
module.exports = {"block":"SignUpModule_block__Cnwp6","container":"SignUpModule_container__Mb_68","message":"SignUpModule_message__Ep7GZ","terms":"SignUpModule_terms__Uvop2"};